document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav-links]');
  if(toggle && nav){ toggle.addEventListener('click', () => nav.classList.toggle('is-open')); }

  document.querySelectorAll('[data-destination-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) e.preventDefault();
    });
  });

  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', (e) => {
      const opt = e.target.options[e.target.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    });
  }
});

// YRH v2: preserve secure top-up context in Shopify line-item properties.
(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('yrh_action') !== 'topup') return;
  const iccid = params.get('yrh_topup_iccid');
  if (!iccid) return;
  document.querySelectorAll('.yrh-product-form').forEach((form) => {
    const action = form.querySelector('[data-yrh-action]');
    const field = form.querySelector('[data-yrh-iccid]');
    if (action) action.value = 'topup';
    if (field) field.value = iccid;
  });
})();


// YRH v3: instant filtering for the complete destination directory.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.all-destinations').forEach((section) => {
    const input = section.querySelector('[data-country-search]');
    const cards = [...section.querySelectorAll('[data-country-card]')];
    const empty = section.querySelector('[data-country-empty]');
    if (!input || !cards.length) return;
    const filterCountries = () => {
      const q = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const match = !q || card.dataset.countryName.includes(q);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    };
    input.addEventListener('input', filterCountries);
  });
});

// YRH v4: compatibility directory search.
document.addEventListener('DOMContentLoaded', () => {
  const directory = document.querySelector('[data-device-directory]');
  const input = document.querySelector('[data-device-search]');
  if (directory && input) {
    const cards = [...directory.querySelectorAll('[data-device-card]')];
    const empty = document.querySelector('[data-device-empty]');
    const count = document.querySelector('[data-device-count]');
    const update = () => {
      const q = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach(card => {
        const match = !q || (card.dataset.deviceName || '').includes(q);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
      if (count) count.textContent = `${visible} group${visible === 1 ? '' : 's'}`;
    };
    input.addEventListener('input', update);
    update();
  }
});

// YRH v4: lightweight smart plan advisor. Recommendation only; checkout always uses live Shopify products.
document.addEventListener('DOMContentLoaded', () => {
  const run = document.querySelector('[data-advisor-run]');
  if (!run) return;
  run.addEventListener('click', () => {
    const destination = (document.querySelector('[data-advisor-destination]')?.value || '').trim();
    const days = Number(document.querySelector('[data-advisor-days]')?.value || 7);
    const usage = document.querySelector('[data-advisor-usage]')?.value || 'medium';
    const result = document.querySelector('[data-advisor-result]');
    if (!result) return;
    if (!destination) {
      result.hidden = false;
      result.innerHTML = '<h3>Add your destination</h3><p>Enter the country or region you are visiting so YRH can link you to matching plans.</p>';
      return;
    }
    let daily = usage === 'light' ? 0.45 : usage === 'medium' ? 1.1 : usage === 'heavy' ? 2.5 : 4;
    const estimate = Math.max(1, Math.ceil(days * daily));
    const recommended = usage === 'unlimited' ? 'Unlimited-data plan' : estimate <= 3 ? '3 GB range' : estimate <= 5 ? '5 GB range' : estimate <= 10 ? '10 GB range' : estimate <= 20 ? '20 GB range' : '20+ GB or Unlimited';
    const q = encodeURIComponent(destination);
    result.hidden = false;
    result.innerHTML = `<h3>${recommended}</h3><p>Estimated for ${days} days with ${usage} usage. This is a planning guide, not a usage guarantee. Compare the live plan terms before checkout.</p><a class="btn btn--sm" href="/search?type=product&q=${q}">See ${destination} plans</a>`;
  });
});
